import styled from "styled-components";
import Colors from "../../makealist/styles/colors";
import { mixFont } from "../../makealist/styles/mixins";
import {
  GenerateInfoText,
  DownloadButtonStyles,
} from "../../makealist/styles/fonts";

const StyledContainer = styled.div`
    && {
        background: white;
        /* position: ${({ isMobile }) => (isMobile ? "fixed" : "absolute")}; */
        position: absolute;
        top: ${({ isMobile }) => (isMobile ? "50px" : "200px")};
        bottom: 0;
        left: 0;
        right: 0;
        z-index: 97;
    }
`;

const StyledInfoBox = styled.div`
  && {
    height: 132px;
    width: 100%;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

const StyledInfoText = styled.div`
  && {
    ${mixFont(GenerateInfoText)}
  }
`;

const StyledAssetContainer = styled.div`
  && {
    width: ${({ isMobile }) => (isMobile ? "auto" : "880px")};
    display: flex;
    flex-direction: "column";
    margin-left: auto;
    margin-right: auto;
    justify-content: center;
  }
`;

const StyledLeftColumn = styled.div`
  && {
    width: 50%;
    background: transparent;
    margin-right: ${({ isMobile }) => (isMobile ? "0" : "45px")};
    display: flex;
    align-items: center;
    flex-direction: column;
    flex: 1 1 auto;
  }
`;

const StyledRightColumn = styled.div`
  && {
    width: 50%;
    align-items: center;
    margin-left: ${({ isMobile }) => (isMobile ? "0" : "45px")};
    background: transparent;
    display: flex;
    align-items: center;
    flex-direction: column;
    flex: 1 1 auto;
  }
`;

const StyledPosterSelector = styled.div`
  && {
    display: flex;
    height: 100px;
    align-items: center;
    justify-content: center;
  }
`;

const StyledButton = styled.div`
  && {
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 10px;
    border: ${({ active }) =>
      active ? `3px solid ${Colors.goldLight}` : "none"};
  }
`;

const StyledHashtag = styled.span`
  font-family: FuturaPT-Book;
  font-size: 16px;
  color: #d2af57;
  line-height: 22px;
  font-weight: normal;
`;

const StyledDownloadButton = styled.button`
  && {
    ${mixFont(DownloadButtonStyles)}
    background: white;
    position: relative;
    border: 1px solid black;
    width: 200px;
    height: 50px;
    margin-top: 30px;
    outline: none;
    cursor: pointer;
    -webkit-transition: border-color 0.3s ease-out, background 0.3s ease-out;
    -moz-transition: border-color 0.3s ease-out, background 0.3s ease-out;
    -ms-transition: border-color 0.3s ease-out, background 0.3s ease-out;
    -o-transition: border-color 0.3s ease-out, background 0.3s ease-out;
    transition: border-color 0.3s ease-out, background 0.3s ease-out;
    &:hover {
      background: #fff;
      border: 1px solid ${Colors.goldLight};
      cursor: pointer;
      color: ${Colors.goldLight} !important;
    }
  }
`;

export {
  StyledContainer,
  StyledInfoBox,
  StyledInfoText,
  StyledAssetContainer,
  StyledRightColumn,
  StyledLeftColumn,
  StyledPosterSelector,
  StyledButton,
  StyledHashtag,
  StyledDownloadButton,
};
